import * as React from 'react'
import { requestServiceData } from '../../utils/requestServiceData'
import { Args, getWidgetProps, Widget, withArgs, WPSClient } from '@utils'
import { Provider } from 'react-redux'
import { AtfComponent } from './component'
import {
  normalizeStringMap,
  normalizeGetPreferences,
  normalizeGetDetailPage,
  NormalizeGetDetailPageType,
  NormalizeStringMapType,
  NormalizeGetPreferencesType
} from '../../data/normalize'
import { configureStore } from '../../store'
import { IDetailPageState } from '../../reducers'
import { safeBoolean } from '../../utils/utils'
import { ErrorBoundary } from '../../components/error/ErrorBoundary'
import { GetAtfInput, getAtfInput } from '../../data/getDetailPageInputs'
import { DVUI } from '@amzn/dvui/dist/DVUI'
import { DPPlaybackArea } from '../../utils/DPPlaybackArea'
import { PurchaseFlowWrapper } from '../../components/purchaseFlowWrapper/purchaseFlowWrapper'
import { StringBundle } from '../../components/localizer/stringBundle'
import { DpWidgetContext } from '../../utils/dpWidgetContext'
import { buildGetString } from '../../utils/stringUtils'
import '../../../../shared/global.module.scss';

export type AtfProps = {
  state: NormalizeGetDetailPageType &
    NormalizeGetPreferencesType &
    Pick<IDetailPageState, 'features'>
  isPageChange?: boolean
} & NormalizeStringMapType

export const getProps: getWidgetProps<AtfProps> = async ({ context, titleID, isCrow, isElcano, atfTreatment, enableSPAGiftCard }, api) => {
  const operation = (wpsClient: WPSClient) => {
    const args: GetAtfInput = { context, titleID, isCrow: safeBoolean(isCrow), isElcano: safeBoolean(isElcano) }
    return wpsClient.GetDetailPage(getAtfInput(args))
  }

  const wpsData = await requestServiceData({
    context,
    api,
    operation,
    stringBundle: StringBundle.ATF,
    titleID,
    requestPreferences: true
  })

  return {
    state: {
      features: {
        isElcano: safeBoolean(isElcano),
        atfTreatment: atfTreatment,
        enableSPAGiftCard: safeBoolean(enableSPAGiftCard)
      },
      ...normalizeGetPreferences(wpsData.preferencesResponse!),
      ...normalizeGetDetailPage(titleID, wpsData.operationResponse),
    },
    ...normalizeStringMap(wpsData.stringMap!),
  }
}

const AtfWidget = (props: AtfProps & Args) => {
  const { logger, context: requestContext, state, isPageChange, strings } = props
  const store = configureStore({ ...state, requestContext }, logger, isPageChange)
  return (
    <DVUI>
      <DpWidgetContext.Provider value={{
        getString: buildGetString(strings, logger, requestContext),
        pageType: state.pageContext.pageType,
        subPageType: state.pageContext.subPageType
      }}>
        <Provider store={store}>
          <ErrorBoundary name='atf'>
            <DPPlaybackArea>
              <AtfComponent />
            </DPPlaybackArea>
          </ErrorBoundary>
          <PurchaseFlowWrapper />
          </Provider>
        </DpWidgetContext.Provider>
    </DVUI>
  )
}

export const Atf: Widget<AtfProps> = {
  name: 'detail-atf',
  getProps: global.__SERVER__ === true ? getProps : undefined,
  Component: withArgs(AtfWidget) as React.ComponentType<any>
}
